/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoPickTicketInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type ExternalTicketShowPickMutationVariables = {
    input: infoPickTicketInput;
};
export type ExternalTicketShowPickMutationResponse = {
    readonly infoPickTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ExternalTicketShowPickMutation = {
    readonly response: ExternalTicketShowPickMutationResponse;
    readonly variables: ExternalTicketShowPickMutationVariables;
};



/*
mutation ExternalTicketShowPickMutation(
  $input: infoPickTicketInput!
) {
  infoPickTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoPickTicketPayload",
    "kind": "LinkedField",
    "name": "infoPickTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalTicketShowPickMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalTicketShowPickMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "76bbe5a2ccb73da52868d7e31a1c246f",
    "id": null,
    "metadata": {},
    "name": "ExternalTicketShowPickMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalTicketShowPickMutation(\n  $input: infoPickTicketInput!\n) {\n  infoPickTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '6e57bbed6ac179a7fdfec88432829537';
export default node;
